module.exports = __webpack_public_path__ + "img/air_pm10.d04902e9.svg";